<ul class="due-date-comparison-tags">
  <li
    *ngFor="let item of data"
    nz-tooltip
    [ngStyle]="{
      cursor: this.clickable ? 'pointer' : 'default',
    }"
    [class.active]="item.active"
    nzTooltipPlacement="top"
    [nzTooltipTitle]="item.title"
    (click)="activate(item.id)"
  >
    {{ item.value }}
  </li>
</ul>
